import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';
import { catalogBibShape, reviewShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectReviews } from 'app/selectors/bibs/ReviewsSelector';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import AllReviewsPage from './AllReviewsPage';

export function AllReviewsPageContainer(props) {
  const { catalogBib, intl } = props;
  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'all_reviews_page_title' }, { title });

  return (
    <div>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <AllReviewsPage {...props} />
    </div>
  );
}

AllReviewsPageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  reviews: ImmutablePropTypes.listOf(reviewShape).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  reviews: selectReviews(state)
});

export default connect(mapStateToProps)(injectIntl(AllReviewsPageContainer));
